import React, { useState , useEffect } from "react"
import Sidebar from "./Sidebar";
import Header from "./Header";
// import CRM from "./CRM";
// import Analyze from "./Analyze"
import Callhistory from "./Callhistory";
// import DoNotDisturb from "./DoNotDisturb";
// import WaitingList from "./WaitingList";
import Dashrigmo from "./Dashrigmo";
// import Agentscce from "./Agentscce";
import { useNavigate } from 'react-router-dom';
import TotalCustomerGrid from "./TotalCustomerGrid";
const AdminDashboard = () => {
  const navigate = useNavigate();
 
const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [view, setView] = useState("Dashboard");
  // const [username, setUsername] = useState(localStorage.getItem("username") || "");
  const [user, setUsers] = useState(null);

//   useEffect(() => {
//     const role = localStorage.getItem("role");
//     const isLoggedIn = localStorage.getItem("isLoggedIn");

//     if (!isLoggedIn || role !== "admin") {
//       navigate("/");
//     } else {
//       fetchUsers();
//     }
//   }, [navigate]);



 useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    setUsers(storedUser);
  }, []);
  

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  };
  return (
    <div className="flex h-screen">
    <Sidebar
      isSidebarOpen={isSidebarOpen}
      setIsSidebarOpen={setIsSidebarOpen}
      setView={setView}
      // username={username}
      handleLogout={handleLogout}
      user={user?.name}
    />
    <div className="flex-1 flex flex-col">
      <Header user={user?.name}  />

      {view === "Dashboard" && <Dashrigmo setView={setView} user={user} ></Dashrigmo>}
      {/* {view === "CRM" && <CRM  user={user}  />} */}
      {/* {view === "Agents-CCE" && <Agentscce user={user} ></Agentscce>} */}

      {view === "TotalCustomers" && <TotalCustomerGrid setView={setView} user={user}></TotalCustomerGrid>}
      
      {view === "CallHistory" && <Callhistory   user={user} />}
      {/* {view === "DoNotDisturb" && <DoNotDisturb user={user}   />} */}

      {/* {view === "WaitingList" && <WaitingList user={user}  ></WaitingList>} */}
    </div>
  </div>
  );
};

export default AdminDashboard;
